/**
 * A signed-in cashier screen: under `/pos/`, but not the PIN pad (`/pos`, the
 * `/pos/s/:code` launcher) or the staff time clock. The KDS, kiosk, pickup and
 * customer displays live outside `/pos/` altogether. PTM-6 — nor the Payment
 * Terminal's working screens (`/pos/pt/…`): a pay-only handheld has no
 * scheduled-order duties.
 *
 * Shared by the root-level alerts that must reach a cashier on any POS screen
 * and nowhere else: SO-2's scheduled-order alerts and OFP-093's print-failure
 * alerts. Moved here from scheduled-order-alerts.service.ts unchanged.
 */
export function isPosOperatorScreen(url: string | null | undefined): boolean {
  if (!url) return false;
  const path = url.split('?')[0].split('#')[0];
  return path.startsWith('/pos/')
    && !path.startsWith('/pos/s/')
    && !path.startsWith('/pos/time-clock')
    && path !== '/pos/pt' && !path.startsWith('/pos/pt/');
}
